import moment from 'moment';

/**
 * ACTION PHOTO DOCUMENT RELEASE INIT
 * Reset release photo document
 */
export const dataAnnotationPhotoDocumentReleaseInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT RELEASE
 * Release photo document
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentRelease = ({ id }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && id !== undefined) {
      dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_PENDING' });
      const firestore = getFirebase().firestore();

      const updateObject = {
        reserved: false,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT RESERVE INIT
 * Reset reserve photo document
 */
export const dataAnnotationPhotoDocumentReserveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT RESERVE
 * Reserve photo document
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentReserve = ({ id }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const authUid = getState().firebase.auth.uid;
    const profileCompany = getState().firebase.profile.company;
    if (
      authUid !== undefined &&
      profileCompany !== undefined &&
      id !== undefined
    ) {
      dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_PENDING' });
      const firestore = getFirebase().firestore();

      const updateObject = {
        reserved: true,
        'vinne_annotation.annotated': false,
        'vinne_annotation.user_id': authUid,
        'vinne_annotation.start_date': moment().unix(),
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT SAVE INIT
 * Reset save photo document
 */
export const dataAnnotationPhotoDocumentSaveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT SAVE
 * Save photo document
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentSave = ({
  id,
  photoTags,
  isChangedPhotoTags = false,
  objects,
  isChangedObjects = false,
  isRejected = false,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      id !== undefined &&
      photoTags !== undefined &&
      objects !== undefined
    ) {
      dispatch({
        type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        reserved: false,
        rejected: isRejected,
        'vinne_annotation.annotated': true,
        'vinne_verification.verified': false,
        'vinne_annotation.end_date': moment().unix(),
        'vinne_annotation.photo.human_correction': isChangedPhotoTags,
        'vinne_annotation.photo.tags': photoTags,
        'vinne_annotation.objects.human_correction': isChangedObjects,
        'vinne_annotation.objects.data': objects,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT FINISH INIT
 * Reset finish photo document
 */
export const dataAnnotationPhotoDocumentFinishInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT FINISH
 * Finish photo document
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentFinish = ({
  id,
  photoTags,
  isChangedPhotoTags = false,
  objects,
  isChangedObjects = false,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      id !== undefined &&
      photoTags !== undefined &&
      objects !== undefined
    ) {
      dispatch({
        type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        reserved: false,
        rejected: false,
        'vinne_annotation.annotated': true,
        'vinne_verification.verified': false,
        'vinne_annotation.end_date': moment().unix(),
        'vinne_annotation.photo.human_correction': isChangedPhotoTags,
        'vinne_annotation.photo.tags': photoTags,
        'vinne_annotation.objects.human_correction': isChangedObjects,
        'vinne_annotation.objects.data': objects,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT DELETE INIT
 * Reset delete photo document
 */
export const dataAnnotationPhotoDocumentDeleteInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT DELETE
 * Delete photo document
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentDelete = ({ id }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && id !== undefined) {
      dispatch({
        type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_PENDING',
      });
      const firebase = getFirebase();
      const firestore = firebase.firestore();

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .get()
        .then(async (snapshot) => {
          const photoDocument = snapshot.data();
          if (photoDocument.video_id) {
            try {
              await firebase
                .storage()
                .ref()
                .child(`waste_photos/${photoDocument.video_id}.mp4`)
                .delete();
            } catch (err) {}
          } else if (photoDocument.photo_id) {
            try {
              await firebase
                .storage()
                .ref()
                .child(`waste_photos/${photoDocument.photo_id}.jpg`)
                .delete();
            } catch (err) {}
          }
          await firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id)
            .delete();
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_DELETE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS RELEASE INIT
 * Reset release photo documents
 */
export const dataAnnotationPhotoDocumentsReleaseInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT RELEASE
 * Release photo documents
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentsRelease = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && ids !== undefined) {
      dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_PENDING' });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        reserved: false,
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RELEASE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS RESERVATION INIT
 * Reset reservation photo documents
 */
export const dataAnnotationPhotoDocumentsReserveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS RESERVATION
 * Reservation photo documents
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentsReserve = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const authUid = getState().firebase.auth.uid;
    const profileCompany = getState().firebase.profile.company;
    if (
      authUid !== undefined &&
      profileCompany !== undefined &&
      ids !== undefined
    ) {
      dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_PENDING' });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        reserved: true,
        'vinne_annotation.annotated': false,
        'vinne_annotation.user_id': authUid,
        'vinne_annotation.start_date': moment().unix(),
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_RESERVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS SAVE INIT
 * Reset finish photo documents
 */
export const dataAnnotationPhotoDocumentsSaveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS SAVE ANNOTATION
 * Save annotation photo documents
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentsSave = ({
  data,
  isRejected = false,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && data !== undefined) {
      dispatch({
        type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      data.forEach((photoDocument) => {
        const updateObject = {
          reserved: false,
          rejected: isRejected,
          'vinne_annotation.annotated': true,
          'vinne_verification.verified': false,
          'vinne_annotation.end_date': moment().unix(),
          'vinne_annotation.photo.human_correction':
            photoDocument.isChangedPhotoTags,
          'vinne_annotation.photo.tags': photoDocument.photoTags,
        };
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(photoDocument.id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_SAVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS FINISH INIT
 * Reset finish photo document
 */
export const dataAnnotationPhotoDocumentsFinishInit = () => {
  return (dispatch) => {
    dispatch({ type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT FINISH ANNOTATION
 * Save annotation photo document
 * @param {object} data - data id
 */
export const dataAnnotationPhotoDocumentsFinish = ({ data }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && data !== undefined) {
      dispatch({
        type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      data.forEach((photoDocument) => {
        const updateObject = {
          reserved: false,
          rejected: false,
          'vinne_annotation.annotated': true,
          'vinne_verification.verified': false,
          'vinne_annotation.end_date': moment().unix(),
          'vinne_annotation.photo.human_correction':
            photoDocument.isChangedPhotoTags,
          'vinne_annotation.photo.tags': photoDocument.photoTags,
        };
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(photoDocument.id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'DATA_ANNOTATION_PHOTO_DOCUMENT_FINISH_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};
